import { useTranslation } from "hooks/useTranslation";
import { MouseEvent } from "react";
import useChat from "hooks/useChat";
import { ButtonProps, styled } from "@mui/material";
import { COLORS } from "constants/layout";
import ButtonBase from "./BaseButton";

const BizChatButton = ({
  identity,
  ...rest
}: { identity?: string } & ButtonProps) => {
  const { onOpenConversationWithIdentity } = useChat();
  const t = useTranslation();

  const onClickButton = (e: MouseEvent<HTMLButtonElement>) => {
    console.log("onClickButton", identity);
    e.stopPropagation();
    e.preventDefault();
    if (identity) {
      onOpenConversationWithIdentity(identity);
    }
  };

  return (
    <StyledButton
      onClick={onClickButton}
      sx={{
        fontSize: "16px",
      }}
      {...rest}
    >
      {t("chat_now")}
    </StyledButton>
  );
};

const StyledButton = styled(ButtonBase)(({ theme }) => ({
  border: `1px solid ${COLORS.green[600]}`,
  color: COLORS.green[600],

  [theme.breakpoints.down("md")]: {
    fontSize: 12,
    ".MuiButton-icon svg": {
      maxHeight: 21,
    },
  },
}));

export default BizChatButton;
